import Vue from "vue";

var persistentTableOptions = {
  mounted() {
    let options = JSON.parse(
      localStorage.getItem("tableoptions.options." + this.$route.name)
    );
    if (options) {
      this.options = options;
    }
    let search = JSON.parse(
      localStorage.getItem("tableoptions.search." + this.$route.name)
    );
    if (search) {
      this.search = search;
    }
    let filters = JSON.parse(
      localStorage.getItem("tableoptions.filters." + this.$route.name)
    );
    if (filters) {
      this.filters = filters;
    }

    document.onkeydown = fkey;
    document.onkeypress = fkey;
    document.onkeyup = fkey;

    var wasPressed = false;

    function fkey(e) {
      e = e || window.event;
      if (wasPressed) return;

      if (e.keyCode == 116) {
        Object.keys(localStorage).map(storage => {
          if (storage.startsWith("tableoptions")) {
            localStorage.removeItem(storage);
          }
        });
        wasPressed = true;
      }
    }
  },
  watch: {
    options: function(oldVal, newVal) {
      localStorage.setItem(
        "tableoptions.options." + this.$route.name,
        JSON.stringify(this.options)
      );
    },
    search: function(oldVal, newVal) {
      localStorage.setItem(
        "tableoptions.search." + this.$route.name,
        JSON.stringify(this.search)
      );
    },
    filters: function(oldVal, newVal) {
      localStorage.setItem(
        "tableoptions.filters." + this.$route.name,
        JSON.stringify(this.filters)
      );
    }
  }
};

export { persistentTableOptions };
